<style>
.header {
    padding: 0 100px 0 60px
}

.header ul {
    height: 48px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.header ul li {
    display: flex;
    align-items: center;
    gap: 28px;
}

.header ul li .gmt_round {
    display: flex;
    align-items: center;
    gap: 28px;
}

.header ul li .personal {
    display: flex;
    align-items: center;
    gap: 5px;
}

.header ul li .round_logo {
    width: 25px;
    height: 25px;
}

.header ul li .real_time p {
    font-size: 14px;
    color: #232020;
}

.header .logo img {
    height: 24px;
}

.footer {
    background: #fff;
    color: #000;
}

.footer .inner {
    padding: 30px 100px;
}

.footer .footer_menu_inner {
    display: flex;
    flex-direction: column;
}

.footer a {
    color: #EEEEEE;
    font-size: 12px;
    line-height: 1.34;
    display: inline-block;
}

.footer .bread_nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.footer .bread_nav .Follow {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
}

.footer .bread_nav .Follow h3 {
    color: #000;
    font-size: 16px;
    font-weight: 900;
}

.footer .bread_nav .Follow .follow_us_a_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
}

.footer .bread_nav .Follow .follow_us_a_box a {
    display: inline-block;
    width: 28px;
    height: 28px;
    position: relative;
}

.follow_us_a1:after {
    content: '';
    position: absolute;
    top: 0px;
    left: 0px;
    width: 28px;
    height: 28px;
    background: url(../assets/img/flow_follow_us_img_01.webp);
    background-size: cover;
}

.follow_us_a1:hover:after {
    background: url(../assets/img/flow_follow_us_img_01_blue.webp);
    background-size: cover;
}

.follow_us_a2:after {
    content: '';
    position: absolute;
    top: 0px;
    left: 0px;
    width: 28px;
    height: 28px;
    background: url(../assets/img/flow_follow_us_img_02.webp);
    background-size: cover;
}

.follow_us_a2:hover:after {
    background: url(../assets/img/flow_follow_us_img_02_blue.webp);
    background-size: cover;
}

.follow_us_a3:after {
    content: '';
    position: absolute;
    top: 0px;
    left: 0px;
    width: 28px;
    height: 28px;
    background: url(../assets/img/flow_follow_us_img_03.webp);
    background-size: cover;
}

.follow_us_a3:hover:after {
    background: url(../assets/img/flow_follow_us_img_03_blue.webp);
    background-size: cover;
}

.footer .bread_nav li.Copyright {
    display: flex;
    color: #000;
}

.footer .bread_nav li.Copyright p {
    font-size: 14px;
}

.el-main {
    padding: 60px;
    background-color: #F3F4F8;
}

.el-menu {
    border-right: 0px
}

.header .inner .round .personal .quit {
    cursor: pointer;
    color: #333;
}

.header .inner .round .personal .quit:hover {
    color: #777;
}
</style>
<template>
    <div>
        <div class="header">
            <div class="inner">
                <ul>
                    <li class="logo"><a href="https://puprime.com/">
                            <img src="../assets/img/logo.webp" alt="">
                        </a></li>
                    <li class="round">
                        <div class="gmt_round">
                            <div class="real_time">
                                <p id="real_time">{{ currentTime }} (GMT+08)</p>
                            </div>
                            <img class="round_logo" src="../assets/img/round_logo.webp" alt="">
                        </div>
                        <div class="personal">
                            <span>Welcome,&lt;{{ user_name }}&gt;</span>
                            <span class="quit" @click="quit()">Log Out</span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <el-container>
            <el-aside width="250px">
                <el-row class="tac">
                    <el-col>
                        <el-menu default-active="1" active-text-color="#006BFF" class="el-menu-vertical-demo">
                            <router-link to="/Dashboard"> 
                                <el-menu-item index="1" @click="qqqq()">
                                    <i class="el-icon-s-home"></i>
                                    <span slot="title">Dashboard</span>
                                </el-menu-item>
                            </router-link>
                            <router-link to="/Publish_Files">
                                <el-menu-item index="2" @click="qqqq()">
                                    <i class="el-icon-user"></i>
                                    <span slot="title">User Management</span>
                                </el-menu-item>
                            </router-link>
                        </el-menu>
                    </el-col>
                </el-row>
            </el-aside>
            <el-main>
                <router-view></router-view>
            </el-main>
        </el-container>
        <div class="footer">
            <div class="inner">
                <ul class="bread_nav">
                    <li class="Follow">
                        <h3>Follow Us</h3>
                        <div class="follow_us_a_box">
                            <a class="follow_us_a1" href="https://www.facebook.com/puprime" target="_blank"></a>
                            <a class="follow_us_a2" href="https://www.linkedin.com/company/puprime" target="_blank"></a>
                            <a class="follow_us_a3" href="https://www.instagram.com/puprime_official"
                                target="_blank"></a>
                        </div>
                    </li>
                    <li class="Copyright">
                        <p>Copyright © 2024. PU Prime</p>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
// import $ from 'jquery'
import cookies from 'js-cookie'
export default {
    data () {
        return {
            currentTime: '',
            personal_result: {},
            user_name: '',
        }
    },
    watch: {
        // 'value'(oldval, newval){
        //     console.log(oldval);
        // },
    },
    created () {
        setInterval(() => {
            this.currentTime = new Date().toLocaleTimeString()
        }, 1000)

    },
    mounted () {
        setTimeout(() => {
            this.getDatas()
        }, 1000)
    },
    beforeDestroy () {
        sessionStorage.setItem("Cookies_Users", 0)
    },
    methods: {
        qqqq(){
            console.log(1);
            sessionStorage.setItem("Cookies_Users", 0)
        },
        getDatas () {
            this.user_name = cookies.get("user_name")
            // let this_f = this
            // $.ajax({
            //     type: "get",
            //     url: "https://google-analytics-test.canglankeji.com/api/user/info",
            //     headers: {
            //         Authorization: "Bearer " + cookies.get("token"),
            //     },
            //     dataType: 'json',
            //     success: function (res) {
            //         // if (res.code != 0) {
            //         //     location.reload()
            //         // }
            //         console.log(res)
            //         // cookies.set('personal', res.result)
            //         this_f.personal_result = res.result
            //     }
            // })
        },
        quit () {
            cookies.remove('token')
            location.reload()
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/pages/Home.vue